// @flow

import Vue from 'vue'

import { logger } from '../common'
import { i18n } from '../common/plugins/i18n'

import Main from './components/Main/Main.vue'
import './index.css'

Vue.config.devtools = false
Vue.config.productionTip = false
Vue.config.errorHandler = (err) => logger.error(err)

export function createApp (store: any): any {
  return new Vue({
    el: '#chatchamp-wizard',
    i18n: i18n,
    store: store,
    render: function (createElement) {
      return createElement(Main)
    }
  })
}
